import {Apps} from "enums";
import {request} from "services/request";
import {createUserIdParam, EnvSetup} from "enums/Envs";
import {AvailableApp} from "services/loginServices";
import {AdminsRoles} from "enums/AdminsRoles";

export interface AdminUser {
    appLinks?: AvailableApp[]
    userKey: string;
    role?: AdminsRoles;
    reviewedUserCount: number;
    isSuperAdmin: boolean;
    token: string;
    name: string;
}

export interface AdminUpdatePayload {
    appLinks: AvailableApp[];
    isSuperAdmin: boolean;
    role?: string;
    name?: string;
}

export const adminsService = {
    getAll: async (env: EnvSetup): Promise<AdminUser[]> => {
        if (env.app === Apps.Instinct) {
            const response = await request<{ users: AdminUser[] }>({
                url: "manage/admins",
                method: 'post',
                data: {}
            });
            return response?.users ?? []
        }
        if (env.app === Apps.Flava) {
            const response = await request<{ profiles: AdminUser[] }>({
                url: "manage/admins",
                method: 'post',
                data: {}
            });
            return response?.profiles ?? []
        }
        if (env.app === Apps.Spark) {
            const response = await request<{ sparkers: AdminUser[] }>({
                url: "manage/admins",
                method: 'post',
                data: {}
            });
            return response?.sparkers ?? []
        }
        alert("adminsService.getAll Not implemented")
        return []
    },
    create: async (name: string, app: Apps, role: AdminsRoles) => {
        return request<AdminUser>({
            url: "manage/create",
            method: 'post',
            data: {name, role, isSuperAdmin: role === AdminsRoles.SuperAdmin}
        });
    },
    block: async (key: string, env: EnvSetup) => {
        return request({
            url: "manage/block",
            method: 'put',
            data: createUserIdParam(env, key)
        });
    },
    regenerate: async (key: string, env: EnvSetup) => {
        return request({
            url: "manage/regenerate-token",
            method: 'put',
            data: createUserIdParam(env, key)
        });
    },
    update: async (key: string, data: AdminUpdatePayload) => {
        return request({
            url: `manage/admins/${key}`,
            method: 'put',
            data,
            withError: true,
        });
    }
}